import styled from 'styled-components';

export const HeaderContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-left: 10px;
    margin-right: 10px;
`;

export const StyledLogo = styled.img`
    margin-right: 10px;
`;

export const StyledText = styled.p`
    color: deepskyblue;
    font-family: Indie Flower, serif;
    font-size: 30px;
`;
